import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const serverMockingAtom = atomWithStorage<boolean>('serverMocking', true);

export const useMockingSetting = () => {
  const [serverMocking, setServerMocking] = useAtom(serverMockingAtom);
  const toggleServerMocking = () => {
    setServerMocking((prev) => !prev);
  };

  return {
    serverMocking,
    toggleServerMocking,
  };
};
